
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Ganesh Chaturthi </h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class>
    <div class="section-lg">
        <div class="container">
            <div class="text-justify">
                <p>GHRCACS, Nagpur, celebrated Ganesh Chaturthi with great
                    devotion and enthusiasm by installing a beautiful Ganesh
                    idol on campus. The vibrant celebration brought students and
                    staff together, fostering a sense of unity and spiritual
                    bliss. The air was filled with joy and prayers as we
                    welcomed Lord Ganesha, the remover of obstacles, with open
                    hearts and minds.</p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh2.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh2.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh3.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh3.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh4.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh4.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh6.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh6.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh7.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh7.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh8.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh8.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh9.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh9.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh10.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh10.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh11.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh11.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh12.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh12.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh13.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh13.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh14.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh14.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh15.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh15.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh16.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh16.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh17.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh17.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh18.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/ganesh18.avif" alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>